import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import { media } from '../utils/style-utils'

const Languages = [
  { name: 'EN', prefix: '' },
  { name: 'NL', prefix: 'nl' },
  { name: 'FR', prefix: 'fr' },
  { name: 'RU', prefix: 'ru' },
  { name: 'DE', prefix: 'de' },
  { name: 'ZH', prefix: 'zh' },
]

const Switch = styled.div`
  background: black;
  color: white;
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 3em;
  text-align: center;
  z-index: 100;

  top: 60px;
  right: 10px;
  margin-right: 0;

  ${media.tablet`
    top: 10vmin;
    right: calc(10vmin / 2);
    margin-right: -1.5em; 
  `};

  a {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
    display: none;
    background: #e7e7e7;
    padding: 0.5em 0;
    color: black;
  }

  &:hover {
    a {
      display: block;
    }
  }

  .is-active {
    order: -1;
    display: block;
    background: black;
    color: inherit;
    pointer-events: none;
  }
`

const LanguageSwitcher = class extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loaded: true }), 600
    })
  }

  state = {
    loaded: false,
  }

  render() {
    const { props } = this

    const { onClick } = props

    const handleClick = e => {
      if (e.target.classList.indexOf('is-active')) return false
    }

    if (this.state.loaded) {
      return (
        <Switch>
          {Languages.map(language => {
            return (
              <Link
                key={language.name}
                exact
                activeClassName="is-active"
                onClick={handleClick}
                to={'/' + language.prefix}
              >
                {language.name}
              </Link>
            )
          })}
        </Switch>
      )
    }
    return <div />
  }
}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.js